<template>
  <section class="costs">
    <h2 class="costs__title">
      {{ $t('WIZARD.COSTS.TITLE') }}
    </h2>
    <div class="costs__container">
      <costs-item
        v-for="(item, index) in items"
        :key="index"
        :image="item.image"
        :title="item.title"
        :content="item.content"
      />
    </div>
  </section>
</template>

<script>
// Components
import CostsItem from '@/components/CostsItem.vue';
// Icons
import { documentsHandover, myHomedayApp, propertyMarketing } from 'homeday-assets/L';
import CONFIG from '@/config/env';

export default {
  name: 'CostsSlide',
  components: {
    CostsItem,
  },
  data() {
    const items = [
      {
        image: documentsHandover,
        title: this.$t('WIZARD.COSTS.ITEMS.PROPERTY_DOCUMENTS_HANDOVER.TITLE'),
        content: this.$t('WIZARD.COSTS.ITEMS.PROPERTY_DOCUMENTS_HANDOVER.CONTENT'),
      },
      {
        image: myHomedayApp,
        title: this.$t('WIZARD.COSTS.ITEMS.MYHOMEDAY_APP.TITLE'),
        content: this.$t('WIZARD.COSTS.ITEMS.MYHOMEDAY_APP.CONTENT'),
      },
    ];

    if (CONFIG.feature_flags.edm_questionnaire) {
      items.push({
        image: propertyMarketing,
        title: this.$t('WIZARD.COSTS.ITEMS.PROPERTY_MARKETING.TITLE'),
        content: this.$t('WIZARD.COSTS.ITEMS.PROPERTY_MARKETING.CONTENT'),
      });
    }

    return {
      items,
    };
  },
};
</script>

<style lang="scss" scoped>
@import '@/styles/mixins.scss';

.costs {
  &__container {
    display: grid;
    grid-row-gap: $sp-m;
    max-width: 960px;
    margin: auto;

    @include for('tablet') {
      grid-template-columns: repeat(auto-fit, minmax(10rem, 1fr));
      grid-column-gap: $sp-m;
      justify-content: center;
    }
  }

  &__title {
    text-align: center;
    margin-bottom: $sp-l;

    @include for('tablet') {
      margin-bottom: #{$sp-xl + $sp-m};
    }
  }
}
</style>
